import { render, staticRenderFns } from "./UploadChunk.vue?vue&type=template&id=3674f880&scoped=true"
import script from "./UploadChunk.vue?vue&type=script&lang=js"
export * from "./UploadChunk.vue?vue&type=script&lang=js"
import style0 from "./UploadChunk.vue?vue&type=style&index=0&id=3674f880&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3674f880",
  null
  
)

export default component.exports